export enum ContactCategory {
  None = "",
  Resistration = "registration",
  Portfolio = "portfolio",
  Offer = "offer",
  Project = "project",
  Topics = "topics",
  Request = "request",
  JobRequest = "jobrequest",
  Chat = "chat",
  Others = "others",
}

export function genContactCategoryOptionArray(): Array<[string, string]> {
  return [
    [ContactCategory.None, "選択してください"],
    [ContactCategory.Resistration, "登録に関して"],
    [ContactCategory.Portfolio, "プロフィールに関して"],
    [ContactCategory.Offer, "オファーに関して"],
    [ContactCategory.Project, "プロジェクトに関して"],
    [ContactCategory.Topics, "トピックスに関して"],
    [ContactCategory.Request, "タイプ・ゲームの追加依頼"],
    [ContactCategory.JobRequest, "お仕事の依頼・協業のご相談"],
    [ContactCategory.Chat, "チャットに関して"],
    [ContactCategory.Others, "その他ご質問・お問い合わせ"],
  ];
}
